import React, { ChangeEvent } from 'react'
import ModalSelectScheduleNotification from './ModalSelectScheduleNotification/ModalSelectScheduleNotification'
import { DeviceNotification, FrecuencyNotification, FrecuencyNotificationId, ScheduleFrecuency, SubjectNotification, TopicNotification } from '../CreateScheduleNotificationForm/CreateScheduleNotificationForm'
import { Schedule } from '../../../../redux/slices/components/ScheduleNotifications/scheduleNotificationsSlice'
import ModalResumeScheduleNotification from './ModalResumeScheduleNotification/ModalResumeScheduleNotification'
import ModalArchivedScheduleNotification from './ModalArchivedScheduleNotification/ModalArchivedScheduleNotification'

type ConModalArchivedScheduleNotificationProps = {
    onSubmit: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void
    onCloseModal: () => void
}

const ConModalArchivedScheduleNotification = ({
    onSubmit,
    onCloseModal,
}: ConModalArchivedScheduleNotificationProps) => {

    const handleClickOutsideModal = (e: any) => {
        const clickOutsideModal = document.getElementById("background-aux-modal")?.contains(e.target);
        if(!clickOutsideModal && e.target.id === "darkened-background-modal"){
            //dispatch( setShowJobModalRequestReducer(false) )
            onCloseModal()
        }
            
    }
  
    return (
        <>
            {
                <div onClick={(e) => { handleClickOutsideModal(e) }} id={"darkened-background-modal"} className="background-gray center">
                    <div id={"background-aux-modal"}>
                          <ModalArchivedScheduleNotification
                                onCloseModal={onCloseModal}
                                onSubmit={onSubmit}
                          />
                    </div>
                </div>
            }
        </>
    )
}

export default React.memo( ConModalArchivedScheduleNotification )